import adminReducer from 'admin/admin.slice';
import { createBrowserHistory } from 'history';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { createReduxHistoryContext } from 'redux-first-history';
import createSagaMiddleware from 'redux-saga';

import bepiReducer from 'bepi/bepi.slice';
import connectivityReducer from 'connectivity/connectivity.slice';
import covidDataSuiteReducer from 'covidDataSuite/covidDataSuite.slice';
import diseaseActivitiesGlobalReducer from 'diseaseActivitiesGlobal/diseaseActivitiesGlobal.slice';
import diseaseActivitiesInCountryLocationsReducer from 'diseaseActivitiesInCountryLocations/diseaseActivitiesInCountryLocations.slice';
import diseaseActivityUpdatesReducer from 'diseaseActivitiesInCountryLocations/diseaseActivityUpdates.slice';
import diseaseActivitiesInLocationReducer from 'diseaseActivitiesInLocation/diseaseActivitiesInLocation.slice';
import diseaseActivitiesRelevantReducer from 'diseaseActivitiesRelevant/diseaseActivitiesRelevant.slice';
import diseaseActivitiesTemporalReducer from 'diseaseActivitiesTemporal/diseaseActivitiesTemporal.slice';
import diseaseActivitiesTimeFrameReducer from 'diseaseActivitiesTimeFrame/diseaseActivitiesTimeFrame.slice';
import diseaseActivityPanelsReducer from 'diseaseActivityPanels/diseaseActivityPanels.slice';
import diseasesReducer from 'diseases/diseases.slice';
import locationsReducer from 'locations/locations.slice';
import metadataReducer from 'metadata/metadata.slice';
import riskOverviewReducer from 'riskOverview/riskOverview.slice';
import userReducer from 'user/user.slice';

import { InsightsState } from './InsightsState';
import {
  NotificationActionType,
  notificationReducer,
  NotificationReduxAction,
} from './notification';
import rootSaga from './sagas';

type InsightsAction =
  | NotificationReduxAction
  | {
      type: NotificationActionType;
    };

// =====================================================================================================================================

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
});

const rootReducer = combineReducers({
  router: routerReducer,
  admin: adminReducer,
  notification: notificationReducer,
  locations: locationsReducer,
  diseases: diseasesReducer,
  bepi: bepiReducer,
  covidDataSuite: covidDataSuiteReducer,
  riskOverview: riskOverviewReducer,
  diseaseActivitiesRelevant: diseaseActivitiesRelevantReducer,
  diseaseActivityPanels: diseaseActivityPanelsReducer,
  diseaseActivitiesInLocation: diseaseActivitiesInLocationReducer,
  diseaseActivitiesGlobal: diseaseActivitiesGlobalReducer,
  diseaseActivitiesTemporal: diseaseActivitiesTemporalReducer,
  diseaseActivitiesTimeFrame: diseaseActivitiesTimeFrameReducer,
  diseaseActivitiesInCountryLocations: diseaseActivitiesInCountryLocationsReducer,
  diseaseActivityUpdates: diseaseActivityUpdatesReducer,
  metadata: metadataReducer,
  connectivity: connectivityReducer,
  user: userReducer,
});

export const rootStore = (() => {
  const sagaMiddleware = createSagaMiddleware();
  const composeEnhancer =
    ((window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
      (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        trace: true,
        traceLimit: 25,
        maxAge: 1000,
      })) ||
    compose;
  const store = createStore<InsightsState, InsightsAction, any, any>(
    rootReducer,
    composeEnhancer(applyMiddleware(sagaMiddleware, routerMiddleware))
  );
  sagaMiddleware.run(rootSaga);
  return store;
})();

export const history = createReduxHistory(rootStore);

export default rootStore;
